import { React, useEffect, useRef, useState } from "react";
import { useAddressList } from "../../../hooks/apis/address";

function Order_delivery({ options = [], handleChangeData }) {
  const { data, isLoading } = useAddressList();

  //   useEffect(() => {
  //     document.querySelectorAll(".delivery-label").forEach((eachLabelElem) =>
  //       eachLabelElem.addEventListener("click", function (elm) {
  //         var pr = document.querySelectorAll(".delivery");
  //         [].forEach.call(pr, function (el) {
  //           el.classList.remove("active");
  //         });
  //         const parent = elm.target.closest(".delivery");
  //         parent.classList.add("active");
  //       })
  //     );
  //   }, []);

  const [value, setValue] = useState(null);
  const [deskNum, setDeskNum] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");

  useEffect(() => {
    if (value === "outsite_delivery") {
      setDeskNum("");
      handleChangeData({
        delivery_type: value,
        shipping_address_id: selectedAddress,
      });
    } else if (value === "inside") {
      handleChangeData({
        delivery_type: value,
        desk_number: deskNum,
      });
    } else {
      setDeskNum("");
      handleChangeData({
        delivery_type: value,
      });
    }
  }, [value, deskNum, selectedAddress]);

  return (
    <div className="form-item">
      <div className="right">
        <label htmlFor="order_delivery">
          <i className="fas fa-luggage-cart"></i>
          روش تحویل سفارش
        </label>
      </div>

      <div className="left">
        {options.map((option, index) => (
          <div
            className={
              value === option.unique_name ? "delivery active" : "delivery"
            }
            onClick={() => {
              setValue(option.unique_name);
            }}
          >
            <label htmlFor="courier" className="delivery-label">
              <i className="fas fa-check"></i>
            </label>
            <span>
              {option.title}
              <small>({option.description})</small>
            </span>
            {value === "outsite_delivery" &&
              option.unique_name === "outsite_delivery" && (
                <>
                  {data[0]
                    .slice(0)
                    .reverse()
                    .map((addressOption, addressIndex) => (
                      <div
                        key={addressIndex}
                        className="delivery"
                        style={
                          selectedAddress === addressOption.id
                            ? {
                                background: "#ed1c24",
                                borderColor: "transparent",
                                cursor: "pointer",
                              }
                            : {
                                background: "none",
                                borderColor: "transparent",
                                cursor: "pointer",
                              }
                        }
                        onClick={() => setSelectedAddress(addressOption.id)}
                      >
                        <input
                          type="radio"
                          name="order_delivery"
                          id={addressOption.unique_name}
                          value={addressOption.unique_name}
                        />

                        <span>{addressOption.address}</span>
                      </div>
                    ))}
                </>
              )}

            {value === "inside" && option.unique_name === "inside" && (
              <input
                className="w-100 border border-secondary rounded text-white"
                type="number"
                name="desknum"
                id="desknum"
                placeholder="شماره میز"
                style={{
                  background: "#454545",
                  padding: "0 10px 0 10px",
                  outline: "0",

                  fontSize: "15px",
                  display: "block",
                }}
                onChange={(event) => setDeskNum(event.target.value)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Order_delivery;
